module.exports = __webpack_public_path__ + "static/img/jiu.a23d42b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/jiu.png
// module id = UC1k
// module chunks = 1